import {Component, OnInit, OnDestroy} from '@angular/core';
import {Router} from '@angular/router';
import {Subscription} from 'rxjs/Subscription';
import {FooterNavbarService} from 'services/connectors/footer-navbar.service';

@Component({
  selector: 'tpc-air-travel-default',
  templateUrl: './air-travel-default.component.html',
  styleUrls: ['./air-travel-default.component.css']
})
export class AirTravelDefaultComponent implements OnInit, OnDestroy {
    private nextSub: Subscription;
    public travelType = 'employee';

    constructor(private footerService: FooterNavbarService,
                private router: Router
    ) {
        this.nextSub = footerService.next$.subscribe(() => this.next());
    }

    ngOnInit() {
    }

    next() {
        this.router.navigate(['/business/travel/' + this.travelType]);
    }

    ngOnDestroy () {
        if (this.nextSub) {
            this.nextSub.unsubscribe();
        }
    }

}



// WEBPACK FOOTER //
// ./src/app/components/calculator/calculator-item/business-calculator/air-travel/air-travel-default/air-travel-default.component.ts